import { useParams, useSearchParams } from 'react-router-dom';

import { useShowCause } from '../api';

// I return the cause from the Url param and also check to see if it's a memberhub cause.
// From here you get the cause data so instead of doing something like
// 1. Get url param
// 2. Save param as cause uuid,
// You can just use this retrieve the cause everytime and use the cause data.uuid to get the uuid.
export const useCauseParam = () => {
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();
  const isMemberhub = searchParams.get('memberhub');
  return useShowCause(uuid, !!isMemberhub);
};
